const styles = (theme) => ({
  detailedChip: {
    display: 'flex',
    zIndex: 1,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: theme.color.gray_0D,
    borderRadius: 10,
    padding: 10,
    color: theme.color.white,
  },

  closeIcon: {
    alignSelf: 'center',
    marginLeft: 10,
  },
});

export default styles;
